<template>
    <div class="quiz">
        <div class="quiz-inner">
            <div class="quiz-inner-forest" v-if="state !== 'quiz'"></div>

            <div class="quiz-inner-status" v-if="state === 'quiz' && !this.card.type_options.is_micro_nudging_quiz">
                <div class="quiz-inner-status-bar" :class="statusClass"></div>
            </div>

            <div class="quiz-inner-content">
                <div v-if="state === 'init'">
                    <div class="quiz-inner-content-top" v-html="__('card_quiz_start_title')"></div>
                    <div class="quiz-inner-content-title" v-html="$processText(card.title)"></div>

                    <div class="quiz-inner-content-btn start" @click="nextQuestion()"
                        v-html="__('card_quiz_start_button')"></div>
                </div>

                <div v-if="state === 'quiz'">
                    <div class="quiz-inner-content-step"><span v-html="__('card_quiz_question_title')"></span> {{ index
                        + 1 }} <span v-html="__('of')"></span> {{ card.type_options.questions.length }}</div>
                    <template v-if="!this.activeMicroNudge">
                        <div class="quiz-inner-content-title" v-html="$processText(currentQuestion.attributes.title)">
                        </div>
                        <div class="quiz-inner-content-btn" :class="answerClass(answer)"
                            v-for="answer in currentQuestion.attributes.answers" :key="answer.key"
                            @click="submitAnswer(answer)">
                            <i v-if="answerClass(answer) === 'correct'" class="fas fa-check"></i>
                            <i v-if="answerClass(answer) === 'wrong'" class="fas fa-times"></i>

                            {{ $processText(answer.attributes.title) }}
                        </div>
                    </template>
                    <template v-else>
                        <div class="quiz-inner-content-title">
                            {{ $processText(this.answerText) }}
                        </div>
                        <v-card-text v-html="$processText(this.activeMicroNudge)" />
                        <div class="quiz-inner-content-btn reset" @click="nextQuestion()"
                            v-html="__('card_quiz_next_button')"></div>
                    </template>
                </div>

                <div v-if="state === 'finished'">
                    <div class="quiz-inner-content-title"
                        v-html="card.type_options.is_micro_nudging_quiz ? card.wysiwyg : card.title">
                    </div>
                    <div class="quiz-inner-content-step" :class="success ? null : 'fail'"
                        v-if="!card.type_options.is_micro_nudging_quiz">{{ success ?
                            __('card_quiz_question_success') : __('card_quiz_question_fail') }}</div>
                    <div class="quiz-inner-content-correct" :class="success ? null : 'fail'"
                        v-if="!card.type_options.is_micro_nudging_quiz">{{ correct }} <span v-html="__('of')"></span> {{
                            card.type_options.questions.length }} <span v-html="__('card_quiz_question_correct')"></span>
                    </div>

                    <img class="mt-3" v-if="success" src="@/assets/img/medalj.png" width="96">

                    <div class="quiz-inner-content-btn reset" @click="reset()">
                        <span v-html="__('card_quiz_question_reset')"></span> <i class="fas fa-chevron-right"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'Quiz',
    props: ['card'],

    data() {
        return {
            index: null,
            state: 'init',
            correct: 0,

            currentInterval: null,

            timeToAnswer: 30000,
            timeUntilNext: 3000,
            answered: null,
            statusClass: '',
            barColor: null,
            activeMicroNudge: null,
            answerText: null,

            quizResponse: {
                cardId: this.card.id,
                uuid: this.card.id,
                score: 0,
                questions: []
            }
        }
    },

    mounted() {
        if (this.lastBehavior && this.lastBehavior.title === 'Finished') {
            this.card.finished = true
        }
    },

    methods: {
        answerClass(answer) {
            if (this.card.type_options.is_micro_nudging_quiz && this.answered === answer.key) {
                return 'correct'
            }
            if (!this.answered) { return }
            if (answer.attributes.correct) { return 'correct' }
            if (this.answered === answer.key && !answer.attributes.correct) { return 'wrong' }
        },

        reset() {
            this.correct = 0
            this.index = null
            this.state = 'init'
            clearTimeout(this.currentInterval)

            this.$metric({ 'event': 'quiz_interaction', 'InteractionType': 'restart', 'QuizName': this.card.title })
        },

        nextQuestion() {
            if (this.index !== null && this.answered !== 'automatic') {
                const jump_to = this.card.type_options.questions[this.index].attributes.answers.find(a => a.key === this.answered).attributes.jump_to

                if (jump_to) {
                    this.index = parseInt(jump_to) - 1
                } else {
                    this.index = this.index + 1
                }
            } else {
                this.index = this.index !== null ? this.index + 1 : 0
            }
            this.answered = null
            this.activeMicroNudge = null

            // If there's no more questions left, jump to finished state
            if (this.index === this.card.type_options.questions.length) {
                this.state = 'finished'

                if (this.success) {
                    this.card.finished = true

                    this.$store.commit('registerBehavior', {
                        title: 'Finished',
                        card_id: this.card.id,
                        end_user_id: this.$store.state.endUser.id
                    })
                }

                setTimeout(() => this.$store.state.sideProfileOpen = true, 4000)

                this.$metric({ 'event': 'quiz_interaction', 'InteractionType': 'finished', 'QuizName': this.card.title })

                return
            }

            // Some logic for GTM events
            if (this.index === 0) {
                this.$metric({ 'event': 'quiz_interaction', 'InteractionType': 'started', 'QuizName': this.card.title })
            }

            this.$metric({ 'event': 'quiz_interaction', 'InteractionType': 'questionloaded-' + (this.index + 1), 'QuizName': this.card.title })
            // End GTM logic

            this.state = 'quiz'
            this.statusClass = 'reset'
            if (!this.card.type_options.is_micro_nudging_quiz) {
                setTimeout(() => { this.statusClass = 'countdown-answer' }, 100)

                clearTimeout(this.currentInterval)
                this.currentInterval = setTimeout(() => { this.submitAnswer() }, this.timeToAnswer)
            }
        },

        submitAnswer(answer) {
            // Prevents people from changing their answer
            if (this.answered) {
                return
            }

            let barClass = 'green'
            let answerScore = null

            if (answer) {
                if (answer.attributes.score && !isNaN(parseInt(answer.attributes.score))) {
                    answerScore = parseInt(answer.attributes.score)
                    this.quizResponse.score += answerScore
                }

                this.quizResponse.questions.push({
                    questionNo: this.index + 1,
                    question: this.currentQuestion.attributes.title,
                    questionKey: this.currentQuestion.key,
                    answerKey: answer.key,
                    answer: answer.attributes.survey_answer_key,
                    score: answerScore
                })

                this.answered = answer.key
                this.activeMicroNudge = answer.attributes.micro_nudge
                this.answerText = answer.attributes.title

                // Check if the answer is correct
                if (answer.attributes.correct || this.card.type_options.is_micro_nudging_quiz) {
                    this.correct++
                } else {
                    barClass = 'red'
                }

                this.$metric({ 'event': 'quiz_interaction', 'InteractionType': 'questionanswered-' + (this.index + 1), 'QuizName': this.card.title })
            } else {
                barClass = 'red'
                // Automatic submit
                this.answered = 'automatic'
            }

            // Jump to next question after X amount of time
            this.statusClass = 'reset'
            if (!this.card.type_options.is_micro_nudging_quiz) {
                setTimeout(() => { this.statusClass = 'countdown-correct ' + barClass }, 100)

                clearTimeout(this.currentInterval)
                this.currentInterval = setTimeout(() => { this.nextQuestion() }, this.timeUntilNext)
            }

            if (this.card.type_options.send_survey) {
                axios.post(this.$apiUrl + '/api/survey/11', {
                    ...this.quizResponse,
                    slug: this.$store.state.endUser.slug,
                })
            }
        }
    },

    computed: {
        success() {
            if (this.card.type_options.correct_answers_to_pass) {
                return this.correct >= parseInt(this.card.type_options.correct_answers_to_pass)
            }

            return this.correct == this.card.type_options.questions.length
        },

        currentQuestion() {
            return this.card.type_options.questions[this.index]
        },

        lastBehavior() {
            if (!this.$store.state.endUser) {
                return null
            }

            let behaviors = this.$store.state.endUser.behaviors
                .filter(b => b.card_id === this.card.id)
                .reverse()

            return behaviors.length > 0 ? behaviors[0] : null
        }
    }
}
</script>
